import type { OrganizationList } from 'models';
import { Card, InformationLineIcon } from 'ui';
import { DetailsOrganization } from './details-organization';

type P = {
  organization: OrganizationList;
};

const DetailsCard = ({ organization }: P) => (
  <Card title={<Card.Title icon={<InformationLineIcon />}>Details</Card.Title>}>
    <DetailsOrganization organization={organization} />
  </Card>
);

export default DetailsCard;
